export default __webpack_public_path__ + "422926e904119477c076ed16496fd796.ttf";